@if ((appContext.activeNavigationItem$ | async)?.config?.url; as url) {
  <e-external-url
    class="dock-y"
    [url]="url"
  ></e-external-url>
}
